import { render, staticRenderFns } from "./QCBatchPermissionEdior.vue?vue&type=template&id=49a45c69&scoped=true&"
import script from "./QCBatchPermissionEdior.vue?vue&type=script&lang=js&"
export * from "./QCBatchPermissionEdior.vue?vue&type=script&lang=js&"
import style0 from "./QCBatchPermissionEdior.vue?vue&type=style&index=0&id=49a45c69&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a45c69",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {
  VAutocomplete,
  VBtn,
  VDialog,
  VForm,
  VIcon,
})
